import {
	FormControl,
	Input,
	InputLabel,
	Typography,
	withStyles
} from '@material-ui/core';
import Button from 'components/Button/Button';
import { Mutation } from 'react-apollo';
import queryString from 'query-string';
import Session from 'utils/session';

import { RESET_PASSWORD } from 'graph/mutations';
import { VALIDATE_TOKEN } from 'graph/queries';
import FullPagePaper from 'components/FullPagePaper/FullPagePaper';

const styles = (theme) => ({
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing.unit,
	},

	submit: {
		marginTop: theme.spacing.unit * 2,
		marginBottom: theme.spacing.unit
	},

	errorMessage: {
		marginTop: theme.spacing.unit,
		color: '#e81d24'
	}
});

class ResetPassword extends Component {
	constructor(props) {
		super(props);

		this.state = {
			password: '',
			confirmPassword: '',
			loading: false,
			error: ''
		};
	}

	render() {
		const { classes } = this.props;

		return (
			<FullPagePaper title="My Homesync" subtitle={i18n.t('login.resetPassword')}>
				<Mutation
					mutation={RESET_PASSWORD}
					update={(cache, { data }) => {
						cache.writeQuery({
							query: VALIDATE_TOKEN,
							data: {
								validateToken: data.resetPassword.user
							}
						});
					}}>
					{(resetPassword, { data, loading }) => (
						<form className={classes.form} onSubmit={(e) => {
							this.resetPassword(resetPassword, e);
						}}>
							<FormControl margin="normal" required fullWidth>
								<InputLabel htmlFor="email">{i18n.t('login.password')}</InputLabel>
								<Input
									id="password"
									name="password"
									type="password"
									autoFocus
									value={this.state.password}
									onChange={(e) => this.setState({ password: e.target.value })} />
							</FormControl>
	
							<FormControl margin="normal" required fullWidth>
								<InputLabel htmlFor="email">{i18n.t('login.confirmPassword')}</InputLabel>
								<Input
									id="confirmPassword"
									name="confirmPassword"
									type="password"
									value={this.state.confirmPassword}
									onChange={(e) => this.setState({ confirmPassword: e.target.value })} />
							</FormControl>
	
							<Button
								type="submit"
								fullWidth
								variant="contained"
								className={classes.submit}
								loading={loading}>
	
								{i18n.t('general.submit')}
							</Button>

							{
								this.state.error ?
								<Typography className={classes.errorMessage} variant="caption">{this.state.error}</Typography>
								: null
							}
						</form>
					)}
				</Mutation>
			</FullPagePaper>
		)
	}

	resetPassword(resetPassword, e) {
		e.preventDefault();

		if (!this.state.password || !this.state.confirmPassword) {
			return;
		}

		if (this.state.password.length < 8) {
			this.setState({
				error: i18n.t('login.passwordLength')
			});

			return;
		}

		if (this.state.password !== this.state.confirmPassword) {
			this.setState({
				error: i18n.t('login.passwordsNotMatch')
			});

			return;
		}

		const { location } = this.props;

		const params = queryString.parse(location.search);

		if (!params.token) {
			return;
		}

		this.setState({
			loading: true
		});

		resetPassword({
			variables: {
				token: params.token,
				password: this.state.password
			}
		}).then((res) => {
			Session.setToken(res.data.resetPassword.token);

			this.props.history.push('/', {
				title: i18n.t('title.home')
			});
		}).catch((e) => {
			this.setState({
				loading: false,
				error: e.graphQLErrors ? e.graphQLErrors.message : e.message
			});
		});
	}
}

export default withStyles(styles)(ResetPassword);